import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { selectLocalScreenshareBroadcasting } from 'features/streaming/streamingSlice';
import { selectMobileScreenshare } from 'features/sdk/sdkStateSlice';
import {
  sdkMobileStartScreenshareRequested,
  sdkMobileStopScreenshareRequested,
} from 'features/sdk/actions';
import { call, put, select } from 'redux-saga/effects';
import { eventBus, ScreenshareMessageTypes } from 'utils/eventBus';
import { RTCClient } from 'utils/webrtc';

export function* onControlScreenshareCommandSaga(command: ScreenshareMessageTypes) {
  const canScreenshare: boolean = yield call(hasPermissionsSaga, PermissionTypes.screenshare);

  if (!canScreenshare) {
    yield call(
      eventBus.forbiddenActionError,
      'Forbidden action. This participant is not allowed to screenshare',
      'screenshare'
    );

    return;
  }

  const mobileScreenshare: boolean = yield select(selectMobileScreenshare);

  switch (command) {
    case 'startScreenshare': {
      // TODO: Consoldidate this with screenshare control
      const isBroadcasting: boolean = yield select(selectLocalScreenshareBroadcasting);

      if (!isBroadcasting) {
        if (mobileScreenshare) {
          yield put(sdkMobileStartScreenshareRequested());
          break;
        }

        try {
          yield call(RTCClient.screensharingFeed.saveStream);
          yield call(RTCClient.screensharingFeed.shareScreen);
        } catch {
          yield call(eventBus.error, {
            name: 'permissions-rejected',
            message: 'Screenshare permissions have been rejected',
          });
        }
      }
      break;
    }
    case 'stopScreenshare':
      if (mobileScreenshare) {
        yield put(sdkMobileStopScreenshareRequested());
        break;
      }

      yield call(RTCClient.screensharingFeed.stopScreenshare);
      break;

    default:
      break;
  }
}
